export default __webpack_public_path__ + "static/media/chandal-hombre.3e667fcb.png";